import React from "react";
import { func } from "prop-types";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";
import { USER_ROLES } from "UTILS/Constants";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class UserDeleteConfirmationModal extends React.Component {

  constructor() {
    super();
  }

  static propTypes = {
    handleYesClick: func,
    handleNoClick: func
  };

  componentWillUnmount() {
    this.disableDeleteBtn(false);
  }

  disableDeleteBtn = (value) => {
    let deleteBtn = document.getElementById("deleteOrganizationBtn");
    if(deleteBtn){
      deleteBtn.disabled = value;
      if(value)
        deleteBtn.classList.add("pointerEventsNone");
      else
        deleteBtn.classList.remove("pointerEventsNone");
    }
  }

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          className="buttons borderBtn bgwhite"
          onClick={() => this.props.handleCancelClick()}
        >
          {getMessage("CANCEL")}
        </Button>
        <Button
          onClick={() => {
            this.disableDeleteBtn(true);
            this.props.handleDeleteClick();
          }
          }
          id="deleteOrganizationBtn"
          className="buttons borderBtn customBtn resetButton whiteOnClick"
          autoFocus
        >
          {getMessage("DELETE")}
        </Button>
      </div>
    );
  };

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="resetPasswordModal"
        toggle={this.props.handleCancelClick}
        backdrop="static"
      >
        <ModalBody>
          {getMessage("DELETE_MSG",
            {deleteTarget: (this.props.deleteTarget)})}
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(UserDeleteConfirmationModal);
